module.exports = __webpack_public_path__ + "static/media/SSMapture.fc42d6e1.png";